module.exports = __webpack_public_path__ + "img/29.c8588898.jpg";